export default __webpack_public_path__ + "static/media/doom.44cc7d52.png";